import { Base } from './base.model';

// Mirror of the API view (trendmulti-api `attendance-whisper.service.ts`, WhisperView):
// `content` is absent once the whisper is deleted; recipient and seen state are never exposed.
export interface AttendanceWhisper extends Base {
  attendance: string;
  user: { _id: string; name?: string };
  content?: string;
  replyTo?: string;
  edited: boolean;
}

export interface AttendanceWhisperCreate {
  attendance: string;
  content: string;
  replyTo?: string;
  // One id per send action; the API refuses a repeat for 60 s (RNF-05).
  clientId: string;
}

// Socket event names — mirrored from the API service; keep both in sync (ADR-002). They differ
// from the room names on purpose: an event named after its room is read as a typed payload.
export const WHISPER_SOCKET_EVENT = 'attendance:whisper';
export const WHISPER_ALERT_SOCKET_EVENT = 'attendance:whisper:alert';

export interface AttendanceWhisperSignal {
  attendanceId: string;
  whisperId: string;
  action: 'created' | 'edited' | 'deleted';
}

export interface AttendanceWhisperAlert {
  attendanceId: string;
  action: 'created' | 'deleted';
  pending: boolean;
}

export const WHISPER_MAX_LENGTH = 4096;
